//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// tutorial-box imports
import { TutorialTeamHealth } from "./tutorial-team-health";
import { IContainer, IProps, IState } from "./TutorialBoxTypes";
// other internals
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
// util
import { validateFlagsErrorable } from "#webapp/src/util/flags.util";
// state
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";

//////////////////
// COMPONENT
//////////////////
class TutorialBoxCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { view, user } = this.props;

    if (!validateFlagsErrorable(user.chromeExtensionFlagsErrorable)) {
      return <span />;
    }

    switch (view) {
      case ChromeAppWrapperView.TeamHealth:
        return <TutorialTeamHealth flags={user.chromeExtensionFlagsErrorable} />;
      default:
        return <span />;
    }
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const TutorialBoxRedux = connect(mapStateToProps, {})(TutorialBoxCmpt);

//////////////////
// RELAY
//////////////////
import { fragments } from "./TutorialBox.gql";
export const TutorialBox = createFragmentContainer<IContainer>(TutorialBoxRedux, fragments);
